import { useEffect, useState } from 'react';

// Raano AI colours, light and dark (design-system.md §9.2). The panel follows the OS colour scheme.
export const AI_THEMES = {
    light: {
        panel: '#FFFFFF', border: '#E0E0E0', text: '#242424', muted: 'rgba(36,36,36,0.6)',
        bubble: '#F0F0F0', card: '#FFFFFF', cardBorder: '#E0E0E0',
        cardBtnBg: '#292929', cardBtnText: '#FFFFFF',
        chipBg: '#FFFFFF', chipBorder: '#D1D1D1', chipText: '#242424',
        input: '#FFFFFF', inputBorder: '#E0E0E0', hover: 'rgba(0,0,0,0.05)',
        avatar: 'linear-gradient(135deg, #2E3133 0%, #000000 100%)',
    },
    dark: {
        panel: '#292929', border: '#525252', text: '#FFFFFF', muted: 'rgba(255,255,255,0.6)',
        bubble: '#0A0A0A', card: '#292929', cardBorder: '#525252',
        cardBtnBg: '#FFFFFF', cardBtnText: '#242424',
        chipBg: '#292929', chipBorder: '#666666', chipText: '#FFFFFF',
        input: '#1F1F1F', inputBorder: '#525252', hover: 'rgba(255,255,255,0.08)',
        avatar: 'linear-gradient(135deg, #4A4D50 0%, #111111 100%)',
    },
};

export const useAiTheme = () => {
    const query = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    const [dark, setDark] = useState(!!query?.matches);
    useEffect(() => {
        if (!query) return;
        const on = (e) => setDark(e.matches);
        query.addEventListener?.('change', on);
        return () => query.removeEventListener?.('change', on);
    }, [query]);
    return AI_THEMES[dark ? 'dark' : 'light'];
};
